import config from "../config";

const storages = {
    JWT: `${config.localStorageName}-jwtToken`,
    INFOS: `${config.localStorageName}-infos`
};

export const getJwtToken = () => {
    const jwtToken = localStorage.getItem(storages.JWT);

    try {
        if (jwtToken) {
            return jwtToken;
        }
        throw new Error("");
    }
    catch (err) {
        return null;
    }
};

export const setJwt = jwtToken => localStorage.setItem(storages.JWT, jwtToken);

export const getLocalInfos = () => {
    const infos = localStorage.getItem(storages.INFOS);

    try {
        if (infos) {
            return JSON.parse(infos);
        }
        throw new Error("");
    }
    catch (err) {
        return null;
    }
};

export const getInfos = infos => localStorage.setItem(storages.INFOS, infos);




// WEBPACK FOOTER //
// ./src/services/tokens.js